import type { K8s } from '@/entities/kubernetes';
import request from '@/shared/api/request';

export const renameKubernetes = (
  uuid: string,
  name: string,
): Promise<{
  kubernetes: K8s;
}> =>
  request({
    url: `/kubernetes/${uuid}/`,
    method: 'PUT',
    data: { name },
  });
